import React from 'react';
import { RuleDot } from './Decor';
import { SECTION_IDS } from '../utils/scroll';
const steps = [{
  number: '01',
  title: 'Definimos',
  body: 'Entendemos tu idea, tus necesidades y en qué etapa se encuentra tu proyecto.'
}, {
  number: '02',
  title: 'Construimos',
  body: 'Creamos la estructura, identidad y herramientas que tu negocio realmente necesita.'
}, {
  number: '03',
  title: 'Lanzamos',
  body: 'Sales al mercado con una presencia profesional y una base preparada para crecer.'
}];
export function Process() {
  return <section id={SECTION_IDS.proceso} aria-labelledby="proceso-titulo" className="relative bg-gradient-to-b from-lavender-50 to-ivory" data-id="element-214" data-mp="1fopevptehgwb">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-8 sm:py-20 lg:py-28" data-id="element-215" data-mp="1kh0d8o8hsumr">
        <RuleDot data-id="element-216" data-mp="mz09z1dkkwpf" />
        <h2 id="proceso-titulo" className="mt-5 max-w-2xl font-display text-[1.7rem] leading-[1.16] text-plum-900 sm:text-4xl lg:text-[2.7rem]" data-id="element-217" data-mp="mzif6ni7ml9h">
          De la idea a un negocio listo para crecer.
        </h2>

        <div className="relative mt-10 sm:mt-16" data-id="element-218" data-mp="15jw2hzaf41ag">
          {/* Progresión visual: línea fina con puntos */}
          <div aria-hidden="true" className="absolute left-[0.4rem] top-2 hidden h-[calc(100%-1rem)] w-px bg-gradient-to-b from-lavender-300 via-lavender-200 to-transparent sm:left-0 sm:top-[0.4rem] sm:h-px sm:w-full sm:bg-gradient-to-r" data-id="element-219" data-mp="10se0r90klwof" />

          <ol className="grid gap-8 sm:grid-cols-3 sm:gap-8 lg:gap-14" data-id="element-220" data-mp="qsdhfn2pbgk8">
            {steps.map(step => <li key={step.number} className="group relative pl-8 sm:pl-0 sm:pt-8" data-id="element-221" data-mp="hu1npc6jg2nk">
                <span aria-hidden="true" className="absolute left-0 top-1.5 h-3 w-3 rounded-full border-2 border-lavender-300 bg-ivory transition-[background-color,border-color,transform] duration-200 ease-premium group-hover:scale-110 group-hover:border-plum-700 group-hover:bg-lavender-100 sm:left-0 sm:top-0" data-id="element-222" data-mp="hvwbcy9728vc" />
                <div className="flex items-baseline gap-4" data-id="element-223" data-mp="2qc1p9rqy8rwx">
                  <span className="font-display text-[2.75rem] leading-none text-lavender-300 transition-colors duration-200 ease-premium group-hover:text-orchid sm:text-6xl lg:text-7xl" data-id="element-224" data-mp="2v4uu0fmf4090">
                    {step.number}
                  </span>
                  <h3 className="eyebrow text-plum-700" data-id="element-225" data-mp="2mc9d752ck3mt">{step.title}</h3>
                </div>
                <p className="mt-3 max-w-xs text-[0.95rem] leading-relaxed text-muted sm:mt-5 sm:text-[0.975rem]" data-id="element-226" data-mp="3a23qtouhpw84">
                  {step.body}
                </p>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}